import { __assign, __rest } from "tslib";
import React from "react";
import { View } from "@tarojs/components";
import classNames from "classnames";
export function Backdrop(_a) {
    var visible = _a.visible, className = _a.className, transparent = _a.transparent, onClick = _a.onClick, props = __rest(_a, ["visible", "className", "transparent", "onClick"]);
    return (React.createElement(View, __assign({}, props, { className: classNames("tea-backdrop", className, {
            "is-shown": visible,
            transparent: transparent,
        }) }),
        React.createElement(View, { className: "tea-backdrop__overlay", onClick: onClick })));
}
//# sourceMappingURL=Backdrop.js.map